/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import logo from "../../Recursos/logo_blaco_redondo.png";
import BarraBusqueda from "./Componentes/BarraBusqueda";
import {useCarritoCompras} from "../../Modulo_Carrito_Wass/Hooks/useCarritoCompras";
import {useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import {contexData} from "../../App";
import {obtenerObjLocal} from "../../Servicios/BDLocal/obtenerObjLocal";

const BarraPc = () => {
    const cData = useContext(contexData)
    const {DialogoCarrito, BotonCarrito} = useCarritoCompras()
    const navigate = useNavigate()
    const [num, setNum] = useState(0)


    const irHome = () => {
        cData.setSubCatEscogida('')
        cData.setIconoCat('')
        navigate('/Home')
    }

    useEffect(() => {
        let peds = obtenerObjLocal({key: 'pedidos'})
        if (peds) {
            setNum(peds.length)
        }
    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            sx={{backgroundColor: theme.palette.primary.main}}
        >

            <DialogoCarrito/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={12}
                sx={{maxWidth: '1400px', px: 2, py: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{ml: -1, mr: 1}}>
                    <img
                        onClick={() => irHome()}
                        src={logo} width={72} height={'auto'} alt={'Logo'} title={'Logo'} style={{cursor: 'pointer'}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{pr: 6, justifyContent: 'flex-end'}}>
                    <BarraBusqueda/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}}>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Typography
                            onClick={() => irHome()}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                color: '#fff',
                                fontWeight: 500,
                                borderBottom: 1,
                                borderColor: '#ffffff00',
                                cursor: 'pointer',
                                '&:hover': {
                                    borderColor: '#fff'
                                }
                            }}>Home</Typography>

                        <Typography
                            onClick={() => navigate('/Ofertas')}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                color: '#fff',
                                fontWeight: 500,
                                borderBottom: 1,
                                borderColor: '#ffffff00',
                                cursor: 'pointer',
                                '&:hover': {
                                    borderColor: '#fff'
                                }
                            }}>Ofertas</Typography>


                        <Badge
                            color={'secondary'}
                            badgeContent={num}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}

                        >

                            <Typography
                                onClick={() => navigate('/Mis_Compras')}
                                sx={{
                                    transition: 'all .2s ease-in-out',
                                    color: '#fff',
                                    fontWeight: 500,
                                    borderBottom: 1,
                                    borderColor: '#ffffff00',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#fff'
                                    }
                                }}>Mis Compras</Typography>
                        </Badge>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>


                    <BotonCarrito/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default BarraPc

